import React, { useState, useEffect } from 'react';
import api from '../api/api';
import '../styles/SupplierManagement.css';

const SupplierManagement = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [editingSupplier, setEditingSupplier] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    notes: '',
  });

  // =====================================================
  // CARGAR PROVEEDORES
  // =====================================================
  useEffect(() => {
    fetchSuppliers();
  }, []);

  const fetchSuppliers = async () => {
    try {
      const res = await api.get('/api/suppliers');
      setSuppliers(res.data);
    } catch (error) {
      console.error('Error al obtener proveedores:', error);
    }
  };

  // =====================================================
  // MODAL
  // =====================================================
  const handleOpenModal = (supplier = null) => {
    if (supplier) {
      setEditingSupplier(supplier);
      setFormData({
        name: supplier.name,
        email: supplier.email || '',
        phone: supplier.phone || '',
        address: supplier.address || '',
        notes: supplier.notes || '',
      });
    } else {
      setEditingSupplier(null);
      setFormData({
        name: '',
        email: '',
        phone: '',
        address: '',
        notes: '',
      });
    }
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingSupplier(null);
  };

  // =====================================================
  // FORM
  // =====================================================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingSupplier) {
        await api.put(`/api/suppliers/${editingSupplier.id}`, formData);
      } else {
        await api.post('/api/suppliers', formData);
      }
      fetchSuppliers();
      handleCloseModal();
    } catch (error) {
      console.error('Error al guardar proveedor:', error);
    }
  };

  // =====================================================
  // DELETE
  // =====================================================
  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este proveedor?')) return;

    try {
      await api.delete(`/api/suppliers/${id}`);
      fetchSuppliers();
    } catch (error) {
      console.error('Error al eliminar proveedor:', error);
    }
  };

  // =====================================================
  // FILTRO
  // =====================================================
  const filteredSuppliers = suppliers.filter((supplier) =>
    supplier.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // =====================================================
  // RENDER
  // =====================================================
  return (
    <div className="supplier-management-container">
      <header className="sm-header">
        <h1>Gestión de Proveedores</h1>
        <div className="sm-search-bar">
          <input
            type="text"
            className="sm-search-input"
            placeholder="Buscar proveedor..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button className="sm-search-button">Buscar</button>
          <button className="sm-add-button" onClick={() => handleOpenModal()}>
            Añadir Proveedor
          </button>
        </div>
      </header>

      <div className="sm-grid">
        {filteredSuppliers.map((supplier) => (
          <div key={supplier.id} className="sm-card">
            <div className="sm-card-body">
              <h3>{supplier.name}</h3>
              {supplier.email && <p>Email: {supplier.email}</p>}
              {supplier.phone && <p>Tel: {supplier.phone}</p>}
              {supplier.address && <p>Dir.: {supplier.address}</p>}
              {supplier.notes && <p>Notas: {supplier.notes}</p>}
              <div className="sm-card-actions">
                <button onClick={() => handleOpenModal(supplier)}>Editar</button>
                <button onClick={() => handleDelete(supplier.id)}>Eliminar</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {modalOpen && (
        <div className="sm-modal-overlay">
          <div className="sm-modal">
            <h2>{editingSupplier ? 'Editar Proveedor' : 'Añadir Proveedor'}</h2>
            <form onSubmit={handleSubmit} className="sm-form">
              <label>
                Nombre:
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                Email:
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </label>

              <label>
                Teléfono:
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </label>

              <label>
                Dirección:
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </label>

              <label>
                Notas:
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                />
              </label>

              <div className="sm-form-actions">
                <button type="submit">
                  {editingSupplier ? 'Actualizar' : 'Crear'}
                </button>
                <button type="button" onClick={handleCloseModal}>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SupplierManagement;
